import React from 'react';
import { Button, ButtonOutline } from '../general/Styles.jsx';
import ResultsList from './ResultsList';
import ResultsMap from './ResultsMap.jsx';
import ResultsCategories from './ResultsCategories';
import styled from 'styled-components';

const StyledTabContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  justify-content: center;
`;

// TODO: This should be an H tag
const StyledHeading = styled.p`
  color: #000;
  margin: 0;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  line-height: 1.125;
  font-size: clamp(24px, 2.5vw, 32px);
`;

const StyledParagraph = styled.p`
  font-size: 14px;
  margin: 0;
  margin-bottom: 24px;
  text-align: center;
`;

const StyledDiv = styled.div`
  display: block;
`;

const StyledSubContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
`;

const StyledSubContainerRow = styled(StyledSubContainer)`
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 30px;
  }
`;

const StyledContentContainer = styled.div`
  flex: 0 40%;
  max-height: 50vh;
  overflow: scroll;
  margin-bottom: 0;
  @media (min-width: 769px) {
    overflow: scroll;
    margin-bottom: 0;
  }
`;

const StyledBackContainer = styled.div`
  float: left;
`;

const StyledTopBar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const StyledResultsContainer = styled.div`
  width: 100%;
`;

const StyledResultsHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
`;

const ResultsMapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

interface DealerResultsProps {
  results: any[];
  back: () => void;
  input: any;
  data: any;
  radius: any;
  site: any;
  buyCodeGroups: any[];
  pagex: any;
  searchCategory: any;
  enableResultsCategories: any;
}

const DealerResults: React.FC<DealerResultsProps> = ({
  results,
  back,
  input,
  data,
  radius,
  site,
  buyCodeGroups,
  pagex,
  searchCategory,
  enableResultsCategories
}) => {
  return (
    <StyledTabContainer id="showcase-dealers-screen">
      <StyledResultsContainer id="showcase-dealers-results" data-header="#showcase-dealer-results-location-title">
        <StyledTopBar id="showcase-dealers-top-bar">
          <StyledBackContainer className="psd-modal-control psd-modal-control-left back-container">
            <span className="back-button">
              <Button theme="none" onClick={() => back()} id="showcase-dealers-screen-back">&larr;</Button>
            </span>
          </StyledBackContainer>
          <StyledSubContainer className="psd-modal-title">
            <StyledHeading id="global-psd-title">Locate a {site} Authorized Dealer</StyledHeading>
          </StyledSubContainer>
        </StyledTopBar>
        <StyledResultsHeader id="showcase-dealers-results-header">
          <StyledParagraph id="showcase-dealer-results-location-title">
            <span className="total">{results.length}</span> results found within {radius} {data.distanceUnit && data.distanceUnit === 'km' ? 'kilometers' : 'miles'} of <span className="total area">{input}</span>
          </StyledParagraph>
          <StyledDiv id="showcase-dealer-results-change">
            <ButtonOutline id="dealerLocatorLocate" theme={site} onClick={() => back()}>Update Location</ButtonOutline>
          </StyledDiv>
        </StyledResultsHeader>
        {buyCodeGroups && buyCodeGroups.length && pagex === 'dealers' && (enableResultsCategories && (enableResultsCategories == true || enableResultsCategories == 'true')) ? (
          <ResultsCategories categories={buyCodeGroups} searchCategory={searchCategory} input={input} data={data} />
        ) : null}
        <StyledSubContainerRow id="showcase-dealers-result-container">
          <StyledContentContainer id="showcase-dealers-result-content">
            <ResultsList results={results} data={data} />
          </StyledContentContainer>
          <ResultsMapContainer id="showcase-dealers-result-map">
            <ResultsMap results={results} data={data} />
          </ResultsMapContainer>
        </StyledSubContainerRow>
      </StyledResultsContainer>
    </StyledTabContainer>
  );
};

export default DealerResults;
